module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village/levelIcon//10_King.png?v=249cae22";